import { render } from "./_Pdf.vue?vue&type=template&id=cb612eb6&scoped=true"
import script from "./_Pdf.vue?vue&type=script&lang=ts"
export * from "./_Pdf.vue?vue&type=script&lang=ts"

import "./_Pdf.vue?vue&type=style&index=0&id=cb612eb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cb612eb6"

export default script